import { Currency } from "./currency.type";
import { IPricing, SalaryType } from "./salary.type";

export enum UserRole {
  Admin = "admin",
  Director = "director",
  Cashier = "cashier",
  WarehouseMgr = "warehouseMgr",
  SalesDept = "salesDept",
  Manager = "manager",
  Accountant = "accountant",
  Foreman = "foreman",
  InventoryMgr = "inventoryMgr",
}

export enum TariffRuleType {
  PriceMargin = "priceMargin",
  OrderVolume = "orderVolume",
  OrderTurnoverPercent = "orderTurnoverPercent",
  CommonOrderTurnoverPercent = "commonOrderTurnoverPercent",
  CommonPriceMarginPercent = "commonPriceMarginPercent",
}

export enum TariffRewardMode {
  PercentOfPrice = "percentOfPrice",
  FixedAmount = "fixedAmount",
}

export interface SalesTariffRule {
  _id?: string;
  name: string;
  type: TariffRuleType;
  thresholdValue: number;
  rewardValue: number;
  rewardMode: TariffRewardMode;
  description?: string;
}

export interface SalesMonthlyStats {
  month?: number;
  year?: number;
  expectedVolume?: number;
  expectedCommission?: number;
  expectedBonuses?: number;
  actualVolume?: number;
  actualCommission?: number;
  actualBonuses?: number;
  salaryReceived?: number;
  totalEarned?: number;
  totalSalesVolume?: number;
  commissionEarned?: number;
  bonusesEarned?: number;
}

export interface SalesProfile {
  salaryAmount?: number;
  salaryCurrency?: Currency;
  tariffRules: SalesTariffRule[];
  balance?: number;
  expectedBalance?: number;
  currentMonthStats?: SalesMonthlyStats;
}

export interface User {
  _id: string;
  username: string;
  name: string;
  password?: string;
  role: UserRole;
  createdAt?: string;
  updatedAt?: string;
  minuteNorm?: number;
  pricings?: IPricing[];
  salaryType?: SalaryType;
  salaryCurrency?: Currency;
  salesProfile?: SalesProfile;
}
